import React, { createContext, PropsWithChildren } from "react";

import {
  ArticleData,
  ArticleId,
  RepeatableContentKey,
} from "@brexhq/next/src/utils/repeatableContent/repeatableContentUtils";

export interface FilteredArticlesContextState {
  repeatableArticles: Record<ArticleId, ArticleData>;
  repeatableBundles: Record<RepeatableContentKey, ArticleId[]>;
}

export const FilteredArticlesContext =
  createContext<FilteredArticlesContextState>({
    repeatableArticles: {},
    repeatableBundles: {},
  });

export const FilteredArticlesContextProvider: React.FC<
  PropsWithChildren<{
    value: FilteredArticlesContextState;
  }>
> = ({ children, value }) => {
  return (
    <FilteredArticlesContext.Provider value={value}>
      {children}
    </FilteredArticlesContext.Provider>
  );
};
